import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22980a97"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }

import { ESTADOS_LISTA } from "@/utils/estadoLista";
import { InscripcionTorneoCreadoDTO } from "@/interfaces/Torneo";
import {
  cancelarInscripcion,
  updateEstadoLista,
  updateEstadoPago,
} from "@/services/InscripcionesService";
import { ref, watch } from "vue";
import { useTorneoCerrado } from "@/composables/useTorneoCerrado";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import {
  getlistaTorneo,
  modificarListaTorneo,
  subirListaTorneo,
} from "@/services/ListasService";
import {
  CrearListaTorneoRequestDTO,
  ListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
} from "@/interfaces/Lista";
import ModalListaGestion from "./ModalListaGestion.vue";
import { ArmyDTO } from "@/interfaces/Army";

// Definir las propiedades y eventos

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDetalleInscripcion',
  props: {
    inscripcion: {}
  },
  emits: ["close", "update-inscripcion", "eliminar-inscripcion"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const cerrado = useTorneoCerrado();

// ModalDetalleInscripcion.vue
const emit = __emit;

const show = ref<boolean>(true);
const showLista = ref<boolean>(false);
const localInscripcion = ref({ ...props.inscripcion });
const isLoading = ref<boolean>(false);
const listaBase64 = ref<string>();
const listaText = ref<string>("");
const ejercito = ref<ArmyDTO>();

// Se guarda SI o NO; se enseña como en el resto de la aplicación
const pagoOptions = [
  { valor: "NO", texto: "No pagado" },
  { valor: "SI", texto: "Pagado" },
];

const showSuccessModalPago = ref<boolean>(false);
const showSuccessModalLista = ref<boolean>(false);
const showSuccessModalEliminar = ref<boolean>(false);
const showSuccessModalSubirLista = ref<boolean>(false);

const showModificarLista = ref<boolean>(false);

const showErrorModal = ref<boolean>(false);

// Registrar el cambio y actualizar en la base de datos
const logChange = async (
  field: "estadoLista" | "esPago",
  value: string | boolean
) => {
  isLoading.value = true;
  try {
    //lista
    if (field === "estadoLista") {
      let estado: string;
      if (value == "NO ENTREGADA") estado = "NO ENTREGADA";
      else if (value == "ENTREGADA") estado = "ENTREGADA";
      else if (value == "ILEGAL") estado = "ILEGAL";
      else estado = "OK";
      await updateEstadoLista({
        idInscripcion: localInscripcion.value.idInscripcion,
        estadoLista: estado,
      });
      showSuccessModalLista.value = true;
      isLoading.value = false;
      emit("update-inscripcion", { field, value: estado });

      //Pago
    } else if (field === "esPago") {
      let estado: string;
      if (value == "NO") estado = "NO";
      else estado = "SI";
      await updateEstadoPago({
        idInscripcion: localInscripcion.value.idInscripcion,
        esPago: estado,
      });
      showSuccessModalPago.value = true;
      isLoading.value = false;
      emit("update-inscripcion", { field, value: estado });
    }
  } catch (error) {
    console.error(`Error actualizando ${field}:`, error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
  }
};

// Solo cuando el organizador lo cambia en esta inscripción: al abrir la de otro jugador también cambian los valores,
// y se volvían a guardar y le llegaba al jugador un correo sin haber cambiado nada
watch(
  () => [localInscripcion.value.idInscripcion, localInscripcion.value.estadoLista] as const,
  ([id, nuevo], [idAnterior, anterior]) => {
    if (id === idAnterior && nuevo !== anterior) {
      logChange("estadoLista", nuevo!);
    }
  }
);

watch(
  () => [localInscripcion.value.idInscripcion, localInscripcion.value.esPago] as const,
  ([id, nuevo], [idAnterior, anterior]) => {
    if (id === idAnterior && nuevo !== anterior) {
      logChange("esPago", nuevo!);
    }
  }
);

// Cerrado tocando fuera o con Escape, como con la X: así no se queda abierto por debajo con el jugador anterior
watch(show, abierto => {
  if (!abierto) emit("close");
});

const toggleLista = async () => {
  showLista.value = !showLista.value;

  if (showLista.value) {
    isLoading.value = true;
    const requestLista: ListaTorneoRequestDTO = {
      idTorneo: localInscripcion.value.idTorneo,
      idUsuario: localInscripcion.value.idUsuario,
    };
    try {
      const response = await getlistaTorneo(requestLista);
      listaBase64.value = response.data.listaData;
    } catch (error) {
      console.error("Error al recuperar la lista.");
    } finally {
      isLoading.value = false;
    }
  }
};

const eliminarInscripcion = async (idInscripcion: number) => {
  try {
    const response = await cancelarInscripcion(idInscripcion);

    if (response.request?.status === 200) {
      showSuccessModalEliminar.value = true;
      emit("eliminar-inscripcion", idInscripcion);
    } else {
      showErrorModal.value = true;
    }
  } catch {
    showErrorModal.value = true;
  } finally {
    show.value = false;
    emit("close");
  }
};

const close = () => {
  show.value = false;
  emit("close");
};

const showModalLista = () => {
  showModificarLista.value = true;
};

const handleEnviarLista = async (newLista: RequesListaDTO) => {
  listaText.value = newLista.listaData;
  ejercito.value = newLista.ejercito;
  await enviarLista(newLista);
};

const enviarLista = async (newLista: RequesListaDTO) => {
  isLoading.value = true;

  if (localInscripcion.value.idLista && localInscripcion.value.idLista != 0) {
    const requestLista: ModificarListaTorneoRequestDTO = {
      idLista: localInscripcion.value.idLista,
      listaData: newLista.listaData,
      ejercito: newLista.ejercito,
    };
    try {
      await modificarListaTorneo(requestLista);
      showSuccessModalSubirLista.value = true;
    } catch {
      showErrorModal.value = true;
    } finally {
      isLoading.value = false;
    }
  } else {
    const requestLista: CrearListaTorneoRequestDTO = {
      idInscripcion: localInscripcion.value.idInscripcion,
      idUsuario: localInscripcion.value.idUsuario,
      idTorneo: localInscripcion.value.idTorneo,
      listaData: newLista.listaData,
      ejercito: newLista.ejercito,
      nick: "",
    };
    try {
      await subirListaTorneo(requestLista);
      showSuccessModalSubirLista.value = true;
    } catch {
      showErrorModal.value = true;
    } finally {
      isLoading.value = false;
    }
  }
};

// Watch para actualizar la inscripción local cuando cambie la inscripción original
watch(
  () => props.inscripcion,
  (newInscripcion) => {
    localInscripcion.value = { ...newInscripcion };
    show.value = true;
  }
);

// Watch para detectar cuando se cierra el modal de éxito
watch(
  () => showSuccessModalSubirLista.value,
  (newValue, oldValue) => {
    if (oldValue && !newValue) {
      recargarPagina();
    }
  }
);

const recargarPagina = () => {
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((show).value = $event)),
      "max-width": "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-title" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.inscripcion?.nick), 1),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  onClick: close,
                  class: "close-button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.inscripcion?.email)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `mailto:${_ctx.inscripcion.email}`,
                  class: "d-block px-4 pb-2 text-body-2 text-medium-emphasis email"
                }, _toDisplayString(_ctx.inscripcion.email), 9, _hoisted_1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "list-item-title" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" LISTA ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_select, {
                              modelValue: localInscripcion.value.estadoLista,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localInscripcion.value.estadoLista) = $event)),
                              items: _unref(ESTADOS_LISTA),
                              "item-title": "corto",
                              "item-value": "valor",
                              label: "Estado",
                              dense: "",
                              "hide-details": "",
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (
                  logChange('estadoLista', localInscripcion.value.estadoLista!)
                ))
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "list-item-title" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" PAGO ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_select, {
                              modelValue: localInscripcion.value.esPago,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localInscripcion.value.esPago) = $event)),
                              items: pagoOptions,
                              "item-title": "texto",
                              "item-value": "valor",
                              label: "Estado",
                              dense: "",
                              "hide-details": "",
                              onInput: _cache[3] || (_cache[3] = ($event: any) => (logChange('esPago', localInscripcion.value.esPago!)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        (!showLista.value)
                          ? (_openBlock(), _createBlock(_component_v_list_item_content, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "orange",
                                  variant: "tonal",
                                  onClick: toggleLista
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Mostrar Lista ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_list_item_content, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "orange",
                                  variant: "tonal",
                                  onClick: toggleLista
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Ocultar Lista ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        (showLista.value)
                          ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_content, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", null, _toDisplayString(localInscripcion.value.ejercito), 1),
                                    _createVNode(_component_v_spacer, { class: "my-3" }),
                                    (listaBase64.value)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: listaBase64.value,
                                          alt: "Lista",
                                          style: {"max-width":"100%","height":"auto"}
                                        }, null, 8, _hoisted_2))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_3, "No hay lista disponible"))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "tonal",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (showModalLista()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Envia/modifica su lista ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (!_unref(cerrado))
                      ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "red",
                                  variant: "tonal",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (eliminarInscripcion(_ctx.inscripcion?.idInscripcion!)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Eliminar inscripción ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalPago.value,
      message: "Estado del pago actualizado.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showSuccessModalPago.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalLista.value,
      message: "Estado de la lista actualizado.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminar.value,
      message: "Inscripción eliminada.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showSuccessModalEliminar.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalSubirLista.value,
      message: "Lista subida con éxito.",
      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showSuccessModalSubirLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalListaGestion, {
      isVisible: showModificarLista.value,
      idLista: localInscripcion.value.idLista!,
      "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showModificarLista.value = $event)),
      onEnviarLista: handleEnviarLista
    }, null, 8, ["isVisible", "idLista"]),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isLoading).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})